export const feedbackTableHeader = [
  { key: "video_name", title: "Video name" },
  { key: "feedback", title: "Feedback" },
  { key: "email_id", title: "Email id" },
  // { key: "user_id", title: "User id" },
  // { key: "account_id", title: "Account id" },
  { key: "created_at", title: "Created at" },
];
